module.exports = __webpack_public_path__ + "img/list-selected.3fae9ee8.svg";